<ng-container *ngIf="ncProgram$ | async as ncProgram">
  <pw-view-title>
    {{ ncProgram.TEXT }}
  </pw-view-title>

  <div class="p4m-grid-4-col">
    <mat-card>
      <mat-card-header>
        <mat-card-title> Allgemein</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div
          style="display: grid; grid-template-columns: auto 1fr; grid-gap: 8px">
          <div style="font-weight: bold">NC-Container</div>
          <div>{{ ncProgram.TEXT }}</div>
          <div style="font-weight: bold">Projekt</div>
          <div>{{ ncProgram.PROJECT_NAME }}</div>
          <div style="font-weight: bold">Teil</div>
          <div>{{ ncProgram.PART_NAME }}</div>
          <div style="font-weight: bold">PSE</div>
          <a (click)="redirect(ncProgram.BEMI_ID)">{{ ncProgram.BEMI_NAME }}</a>
          <div style="font-weight: bold">Aufspannung</div>
          <a (click)="redirect(ncProgram.POS_ID)">{{ ncProgram.POS_NAME }}</a>
        </div>
      </mat-card-content>
    </mat-card>


    <mat-card *ngIf="ncFileObjects$ | async as ncFiles">
      <mat-card-header>
        <mat-card-title> NC-Files</mat-card-title>
      </mat-card-header>
      <mat-card-content *ngIf="ncFiles.length > 0; else noNcFiles">
        <app-document-list [documents]="ncFiles"></app-document-list>
      </mat-card-content>
      <ng-template #noNcFiles>
        <mat-card-content> Keine NC-Programme gefunden</mat-card-content>
      </ng-template>
    </mat-card>

  </div>
</ng-container>
